import React, { useState } from 'react'
import './FAQ.css'

const faqData = [
  {
    q: "How long does a typical project take?",
    a: "Most small to mid-sized sites take 1–3 weeks depending on scope. I'll give you a clear timeline after our first call.",
  },
  {
    q: "Do you offer support after launch?",
    a: "Yes — I offer ongoing maintenance, or you can reach out anytime for updates and fixes as needed.",
  },
  {
    q: "What if I don't have a fixed budget yet?",
    a: "No problem — just pick 'Not sure yet' in the form. We'll figure out a scope that fits what you're comfortable spending.",
  },
  {
    q: "Can you work with an existing design or codebase?",
    a: "Absolutely. I can build from your Figma files, or jump into an existing project and continue from there.",
  },
  {
    q: "How do we communicate during the project?",
    a: "Mostly WhatsApp and email, whichever you prefer. I'll send progress updates at each milestone.",
  },
]

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null)

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section className="faq-section">
      <div className="section-tag">
        <hr />
        <span>.faq</span>
      </div>
      <h2 className="faq-title">Common Questions</h2>

      <div className="faq-list">
        {faqData.map((item, index) => (
          <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
            <button className="faq-question" onClick={() => toggle(index)}>
              <span>{item.q}</span>
              <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
            </button>
            <div className="faq-answer">
              <p>{item.a}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default FAQ
